import styled, { css } from 'styled-components'

const SideBarSize = 78

export const Container = styled.main`
  width: 100vw;
  min-height: calc(100vh - 200px);
  margin-top: 50px;
  padding: 0 1.5rem;

  @media only screen and (min-width: 800px) {
    margin: 60px 32px 0 ${SideBarSize + 32}px;
    padding: 0;

    width: unset;
  }

  p,
  button,
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 0;
    padding: 0;
  }
`

export const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  .divBeta {
    display: flex;
    flex-direction: row;
  }
  .page-title {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;

    margin-bottom: 22px;

    .go-back {
      border: 0;
      background: 0;

      width: 20px;
      height: 20px;

      .icon {
        width: 100%;
        height: 100%;

        color: rgb(${({ theme }) => theme.primary.base});
      }
    }
  }

  .beta {
    border-radius: 2px;
    align-items: center;
    padding: 2px;
    font-family: 'Montserrat';
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    width: 42px;
    height: 20px;
    background-color: ${({ theme }) =>
      theme.isDark ? 'rgba(8, 137, 198, 1)' : 'rgba(50, 183, 246, 0.3)'};
    color: ${({ theme }) => (theme.isDark ? 'rgba(182, 229, 252, 1)' : 'rgba(5, 81, 117, 1)')};
    margin-left: 0.5rem;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 20px;

    margin-bottom: 30px;
  }

  .see-more-button {
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

    background: none;

    color: ${({ theme }) => `rgb(${theme.primary.base})`};

    width: 100%;

    padding: 12px 0;

    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  @media only screen and (min-width: 800px) {
    .page-title {
      font-size: 24px;

      margin-bottom: 48px;

      .go-back {
        width: 24px;
        height: 24px;
      }
    }

    .inputs {
      flex-direction: row;

      .text-dropdown {
        min-width: 288px;
      }
    }

    .see-more-button {
      font-size: 16px;
      line-height: 22px;
    }
  }
`

export const SearchBar = styled.label`
  border-radius: 8px;
  width: 100%;

  padding: 1rem;

  display: flex;
  align-items: center;
  justify-content: space-between;
  border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

  svg {
    height: 1rem;
    margin-right: 0.5rem;
    color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
  }

  input {
    border: none;
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    width: 100%;
    font-size: 1.125rem;

    &::placeholder {
      color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
    }
  }
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .loading-block {
    height: 230px;
  }

  @media only screen and (min-width: 800px) {
    .loading-block {
      height: 120px;
    }
  }
`

export const ExpandableList = styled(List)<{ fullHeight: number; isExpanded: boolean }>`
  max-height: 0;

  transition: all 0.3s ease-in-out;

  overflow: hidden;

  margin-top: 16px;

  ${({ isExpanded, fullHeight }) =>
    isExpanded &&
    css`
      max-height: ${fullHeight}px;
      margin-bottom: 16px;

      animation: expand 0.3s ease-in-out forwards;
    `}

  @keyframes expand {
    from {
      margin-right: 0;
      max-height: 0;
    }

    to {
      max-height: ${({ fullHeight }) => fullHeight}px;
      margin-bottom: 16px;

      overflow: visible;
    }
  }
`

export const Empty = styled.div`
  display: flex;
  gap: 34px;
  align-items: center;
  flex-direction: column;

  padding: 38px 26px 50px 26px;

  border-radius: 5px;
  border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

  .icon {
    width: 42px;
    height: 42px;

    color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
  }

  .text {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;

    text-align: center;
  }

  .link {
    color: ${({ theme }) => `rgb(${theme.background.low})`};
    background-color: ${({ theme }) => `rgb(${theme.primary.base})`};

    padding: 12px 16px;

    border-radius: 4px;

    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  @media only screen and (min-width: 800px) {
    padding: 130px 0 200px 0;

    gap: 0;

    .icon {
      width: 66px;
      height: 66px;

      margin-bottom: 60px;
    }

    .text {
      font-size: 24px;
      line-height: 31px;

      margin-bottom: 40px;
    }

    .link {
      font-size: 16px;
      line-height: 22px;

      padding: 14px 21px;
    }
  }
`
